import React, { useEffect, useRef, useState } from 'react';
import { initialChat, SESSION_NAME } from '../../../constants/chatbot';
import { Action, IChatState } from '../../../interfaces/chat.interface';
import { createSession, sendMessage } from '../../../services/chatbot.services';
import ChatHeader from '../../atoms/chat/header/ChatHeader';
import ChatInput from '../../atoms/chat/input/ChatInput';
import ChatText from '../../atoms/chat/text/ChatText';
import './ChatBox.scss';

// @ts-ignore
import chatIcon from '../../../assets/icons/CDA/chat.svg';

interface IProps {
    chatState: IChatState;
    setChatState: React.Dispatch<Action>;
}

const ChatBox = ({ chatState, setChatState }: IProps) => {
    const [loadingChatResponse, setLoadingChatResponse] = useState(false);

    const chatHistoryRef = useRef<HTMLDivElement>(null);

    const handleScroll = () => {
        const contenedor = chatHistoryRef.current;
        if (contenedor) {
            contenedor.scrollTop = contenedor.scrollHeight;
        }
    };

    const handleSendMessage = async () => {
        const lastUserMessage = chatState.chatData
            .slice()
            .reverse()
            .find((message) => message.from === 'Usuario');

        if (lastUserMessage && chatState.sessionId) {
            setLoadingChatResponse(true);
            const res = await sendMessage(
                chatState.sessionData,
                lastUserMessage.message,
                chatState.sessionId
            );
            setLoadingChatResponse(false);
            if (res?.text) {
                setChatState({
                    type: 'ADD_MESSAGE',
                    message: {
                        id: res.message_id,
                        from: 'Comfama',
                        message: res.text,
                        vote: null,
                    },
                });
            }
        }
    };

    useEffect(() => {
        handleScroll();
    }, [chatState.chatData, loadingChatResponse]);

    useEffect(() => {
        if (!chatState.sessionId) {
            setLoadingChatResponse(true);
            createSession(chatState.sessionData, SESSION_NAME).then((res) => {
                setChatState({
                    type: 'SET_STATE',
                    newState: { sessionId: res.session_id },
                });
                setLoadingChatResponse(false);
                setChatState({ type: 'ADD_MESSAGE', message: initialChat });
            });
        }
    }, []);

    return (
        <div className="m-chatBox">
            <ChatHeader chatState={chatState} setChatState={setChatState} />

            <div className="m-chatBox__content">
                <div
                    className="m-chatBox__content__history"
                    ref={chatHistoryRef}
                >
                    {chatState.chatData?.map((data) => (
                        <ChatText
                            key={data.id}
                            messageData={data}
                            chatState={chatState}
                            setChatState={setChatState}
                        />
                    ))}

                    {loadingChatResponse && (
                        <div className="m-chatBox__loader">
                            <img
                                className="m-chatBox__loader__img"
                                src={chatIcon}
                                alt="chat icon"
                            />
                            <div className="m-chatBox__loader__ellipsis" />
                        </div>
                    )}
                </div>

                <hr />

                <div className="m-chatBox__content__input__container">
                    <ChatInput
                        chatState={chatState}
                        setChatState={setChatState}
                        handleSendMessage={handleSendMessage}
                    />
                </div>
            </div>
        </div>
    );
};

export default ChatBox;
